// MemberForm is responsible for providing front end validation of
// member submitted data.

// The fields it validates as standard are listed at the bottom of
// this file in MemberForm.data, and the validation messages used are
// pulled from window.Settings['validation_errors'].  Changes to messges can be
// made in the locale files, but additions require changing
// ./app/views/_settigns.erb as well

// To correctly display the validation errors the input elmement in
// question requires a parent element with a class of
// 'js-member-{fieldname}' - e.g. 'js-member-firstname'.

// If additional fields need to be validated these can be added to the
// MemberForm.data array as so (taken from rmail action as example)
//  MemberForm.data.push('subject');
//  MemberForm.data.push('body');


export class MemberField {
  constructor(form, datum, field, known_data) {
    this.form = form;
    this.datum = datum;
    this.field = field;
    this.known_data = known_data;

    if (this.datum.includes('custom_field')) {
      this.$container = $(`#${this.field}`, this.form).eq(0);
      this.field = null;
    } else {
      this.$container = $(`.js-member-${this.datum}`, this.form).eq(0);
    }

    // Prefer non-hidden fields, hidden fields may be used for default values in checkbox hacks
    // http://api.rubyonrails.org/v5.1/classes/ActionView/Helpers/FormHelper.html#method-i-check_box
    this.field || (this.field = $("input[type!='hidden'], select, textarea", this.$container)[0]);
    this.field || (this.field = $("input[type='hidden']", this.$container)[0]);
  }

  warn() {
    $(this.field).addClass('invalid-form-element');
    const warning = this.$container.find('.invalid-form-element-error')[0];

    if (warning == null) {
      if (this.datum === 'postcode' && !Settings.countries && !Settings.counties) {
        this.$container.append(`<div class="invalid-form-element-error" id="aria-postcode-error">
                                 ${Settings.validation_errors.postcode}<br/>
                                 <a href="#" class="js-not-from-here">
                                    ${Settings.validation_errors.not_from_here}
                                 </a>
                               </div>`);
      } else if (this.datum.includes('custom_field')) {
        this.$container.append(`<div class="invalid-form-element-error">
                               ${Settings.validation_errors.custom_field}
                               </div>`);
      } else {
        let id_string = '';
        if (this.field.getAttribute('aria-describedby')) {
          id_string = `id="${this.field.getAttribute('aria-describedby')}"`;
        }
        this.$container.append(`<div class="invalid-form-element-error" ${id_string}>
                               ${this.field.getAttribute('data-error-msg') || Settings.validation_errors[this.datum]}
                               </div>`);
      }
      if (this.datum === 'postcode') {
        this.$container.append(`<div class="not-from-here js-not-from-here-text">
                               ${Settings.validation_errors.not_from_here_explanation}
                               </div>`);
        this.$container.find('.js-not-from-here').on('click', (ev) => {
          ev.preventDefault();
          this.$container.find('.js-not-from-here').hide();
          return this.$container.find('.js-not-from-here-text').show();
        });
      }
    }
  }

  clear() {
    $(this.field).removeClass('invalid-form-element');
    const warning = this.$container.find('.invalid-form-element-error');
    warning.remove();
  }

  is_valid() {
    if ([null, undefined].includes(this.field)) {
      return true;
    }
    if (this.field.disabled) {
      return true;
    }
    if (this.datum === 'name' && (this.known_data.includes('firstname') || this.known_data.includes('lastname'))) {
      return true;
    } if (this.known_data.includes(this.datum)) {
      return true;
    }
    if (this.datum === 'firstname' || this.datum === 'lastname' || this.datum === 'name') {
      if (!this.name_valid()) {
        this.warn()
        return false;
      }
    }
    if (this.datum === 'email') {
      // Our validation is more thorough and strips spaces that the browser wouldn't let pass, so we execute it first
      if (!this.email_valid()) {
        this.warn();
        return false;
      }
    }
    if (this.datum === 'postcode') {
      const required = this.field.getAttribute('required');
      if (!this.postcode_valid() && required) {
        this.warn();
        return false;
      }
    }

    if (this.datum === 'phone') {
      const required = this.field.getAttribute('required');
      if (!this.field.value && required) {
        this.warn();
        return false;
      }
    }

    if (!this.field.checkValidity()) {
      this.warn();
      return false;
    }

    if (this.datum === 'terms_and_conditions') {
      if (!this.terms_and_conditions_valid()) {
        this.warn();
        return false;
      }
    }

    if (this.datum.startsWith('consent')) {
      const { requiredValue } = this.$container.data();
      if (requiredValue !== undefined) {
        if ($(this.$container.find('input:checked')).val() != requiredValue) {
          this.warn();
          return false;
        }
      }
    }

    this.clear();
    return true;
  }

  name_valid() {
    const name = this.field.value;
    // Is someone trying to put a URL in the name field?
    const urlRegex = RegExp('(.*http.*)|(.*www.*)|(.*mailto.*)');
    return !urlRegex.test(name.toLowerCase());
  }

  email_valid() {
    const email = this.field.value = this.field.value.replace(/\s/g, '');
    // From http://emailregex.com/
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(email)) {
      return false;
    }
    return true;
  }

  postcode_valid() {
    if (!Settings.validate_zips) {
      return true;
    }
    const postcode = this.field.value.replace(/\s/g, '');
    const regex = Settings.zip_format[Settings.zip];
    if (!regex.test(postcode)) {
      return false;
    }
    return true;
  }

  terms_and_conditions_valid() {
    if (!Settings.validate_terms_and_conditions) {
      return true;
    }
    return this.field.checked;
  }
}

export class MemberForm {
  constructor(form) {
    this.form = form;
  }

  is_valid() {
    let valid = true;

    const known_member_data = $(this.form).find('input[name=known_member_data]');
    const known_member_data_arr = (known_member_data && known_member_data.val() ? known_member_data.val().split(',') : []);

    let fld;
    for (const datum of MemberForm.data) {
      if (datum === 'terms_and_conditions') {
        const terms = this.form.querySelector('.js-terms-and-conditions');
        if (terms === null) {
          continue;
        }
        fld = new MemberField(this.form, datum, terms, known_member_data_arr);
      } else {
        fld = new MemberField(this.form, datum, null, known_member_data_arr);
      }
      valid &= fld.is_valid();
    }

    // Custom fields
    $('[id^="js-member-custom_field"]').toArray().forEach((el) => {
      fld = new MemberField(this.form, 'custom_field', el.id, known_member_data_arr);
      valid &= fld.is_valid();
    });

    valid &= this.form.checkValidity();

    if (!valid) {
      const aria_error_message = 'There are one or more errors in your form input - please check and try again.';
      $('#aria_live_errors').html(aria_error_message);
    }

    return valid;
  }
}

MemberForm.data = [
  'firstname',
  'lastname',
  'name',
  'email',
  'postcode',
  'town',
  'address1',
  'phone',
  'representative',
  'terms_and_conditions',
  'consent-1',
  'consent-2',
  'consent-3',
  'consent-4',
  'consent-5',
];
